import { Component, OnInit } from '@angular/core';
import *as Constants from 'src/app/models/Constants';
import { LogService } from 'src/app/services/log.service';
import { OtcService } from 'src/app/services/otc.service';
import { RootScopeService } from 'src/app/services/root-scope.service';


@Component({
  selector: 'app-one-time-code',
  templateUrl: './one-time-code.component.html',
  styleUrls: ['./one-time-code.component.scss']
})

export class OneTimeCodeComponent implements OnInit {

  beforeStep1Active = Constants.AUTHENTICATION_OTC_STEPS.BEFORE_STEP1_ACTIVATE;
  onStep1Active = Constants.AUTHENTICATION_OTC_STEPS.ON_STEP1_ACTIVATE;
  onStep2Active = Constants.AUTHENTICATION_OTC_STEPS.ON_STEP2_ACTIVATE;
  onStep3Active = Constants.AUTHENTICATION_OTC_STEPS.ON_STEP3_ACTIVATE;
  generateOtcApiFailErrMsg = Constants.OTC_MESSAGES.GENERATE_OTC_API_FAIL_ERR_MSG;
  notEligibleErrMsg = Constants.OTC_MESSAGES.NOT_ELIGIBLE_ERR_MSG;
  deniedErrMsg = Constants.OTC_MESSAGES.DENIED_ERR_MSG;
  noConfigForDeliveryMethods = Constants.OTC_MESSAGES.NO_CONFIG_FOR_DELIVER_METHODS;
  accountLockedMsg = Constants.OTC_MESSAGES.ACCOUNT_LOCKED;
  invalidOTCMsg = Constants.OTC_MESSAGES.INVALID_OTC;
  validateOtcApiFailureMsg = Constants.OTC_MESSAGES.VALIDATE_OTC_API_FAIL_ERR_MSG;
  otcExpiredMsg = Constants.OTC_MESSAGES.OTC_EXPIRED;
  noMobileNumberAvailableMsg=Constants.OTC_MESSAGES;
  email = Constants.OTC_MODES.EMAIL;
  text = Constants.OTC_MODES.TEXT;
  selectedOption:any;
  fileName: string = "one-time-code_component";
  constructor(public rootScope: RootScopeService,
    public otcService: OtcService,public logger:LogService
  ) { }

  ngOnInit(): void {
    this.rootScope.activeCustTab.otcData.validateOTCApiProcessing = false;
    this.getSelectedOption();

  }

  getActiveStep() {
    const { step1Active, step2Active, step3Active } = this.rootScope.activeCustTab?.otcData;

    switch (true) {
      case !step1Active && !step2Active && !step3Active:
        return Constants.AUTHENTICATION_OTC_STEPS.BEFORE_STEP1_ACTIVATE;

      case step1Active && !step2Active && !step3Active:
        return Constants.AUTHENTICATION_OTC_STEPS.ON_STEP1_ACTIVATE;

      case step1Active && step2Active && !step3Active:
        return Constants.AUTHENTICATION_OTC_STEPS.ON_STEP2_ACTIVATE;

      case step1Active && step2Active && step3Active:
        return Constants.AUTHENTICATION_OTC_STEPS.ON_STEP3_ACTIVATE;

      default:
        return 'invalidState';
    }
  }

  onclickReqOtc() {
    this.rootScope.activeCustTab.otcData.step1Active = true;
    this.logger.infoLogs('OTC Step 1 Active for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }


  continueOnStep1() {
    this.rootScope.activeCustTab.otcData.step2Active = true;
    this.logger.infoLogs('OTC Step 2 Active for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }


  continueOnStep2() {

    if (this.rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.type == Constants.OTC_MODES.TEXT) {
      this.rootScope.activeCustTab.otcData.selectedCountryCode = this.selectedOption?.countryCode;
      this.otcService.openCountryCodeDialog = true;
    } else {
      this.rootScope.activeCustTab.otcData.step3Active = true;
      this.logger.infoLogs('OTC Step 3 Active for customerSessionId:' + this.rootScope.activeCustTab.customerSessionId, this.fileName);
    }
  }

  
  backOnStep2() {
    this.rootScope.activeCustTab.otcData.step2Active = false;
    this.rootScope.activeCustTab.otcData.selectedPhoneNumber = '';
    this.rootScope.activeCustTab.otcData.selectedCountryCode = '';
    this.selectedOption = null; // Reset selected option
    this.rootScope.activeCustTab.otcData.selectedEmail = '';
    this.logger.infoLogs('OTC Step 2 Deactivated for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }

  backOnStep3() {
    this.rootScope.activeCustTab.otcData.step3Active = false;
    this.rootScope.activeCustTab.otcData.notEligiblePhoneNumber = false;
    this.rootScope.activeCustTab.otcData.otcDenied = false;
    this.rootScope.activeCustTab.otcData.generateOTCApiFailure = false;
    this.logger.infoLogs('OTC Step 3 Deactivated for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }

  backOnSendOTCScreen() {
    this.rootScope.activeCustTab.otcData.sendOTCSuccess = false;
    this.logger.infoLogs('OTC Send OTC Screen Deactivated for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }

  isSelectedDeliveryMethodEmpty(): boolean {
    return !this.rootScope.activeCustTab.otcData.selectedDeliveryMethod ||
      Object.keys(this.rootScope.activeCustTab.otcData.selectedDeliveryMethod)?.length === 0;
  }


  onClickEnterOTC() {
    this.rootScope.activeCustTab.otcData.enterOTCScreen = true;
    this.logger.infoLogs('OTC Enter OTC Screen Activated for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }

  backOnGenerateOTCScreen() {
    this.rootScope.activeCustTab.otcData.sendOTCSuccess = false;
    this.logger.infoLogs('OTC Generate OTC Screen Deactivated for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }

  clickEnterOTCButton() {
    this.rootScope.activeCustTab.otcData.enterOTCScreen = true;
    this.otcService.oneTimeCode.enable();
    this.rootScope.activeCustTab.otcData.otcExpired = false;
    this.rootScope.activeCustTab.otcData.typedOTC = '';  
    this.rootScope.activeCustTab.otcData.validateOtcFail = false;
    this.rootScope.activeCustTab.otcData.validateOtcLocked = false;
    this.rootScope.activeCustTab.otcData.validateOtcApiFailure = false; 
    this.rootScope.activeCustTab.otcData.otcExpired = false;
    this.otcService.oneTimeCode.reset();
    this.logger.infoLogs('OTC Enter OTC Button Clicked for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }


  verifyCode() {
    const otc = this.otcService.oneTimeCode?.value;
    this.otcService.validateOTC(otc);
    this.logger.infoLogs('OTC Verify Code Clicked for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }


  cancelVerifyCode() {
    this.rootScope.activeCustTab.otcData.step1Active = false;
    this.rootScope.activeCustTab.otcData.step2Active = false;
    this.rootScope.activeCustTab.otcData.step3Active = false;
    this.rootScope.activeCustTab.otcData.sendOTCSuccess = false;
    this.rootScope.activeCustTab.otcData.otcDenied = false;
    this.rootScope.activeCustTab.otcData.notEligiblePhoneNumber = false;
    this.rootScope.activeCustTab.otcData.enterOTCScreen = false;
    this.rootScope.activeCustTab.otcData.generateOTCApiFailure = false;
    this.rootScope.activeCustTab.otcData.selectedDeliveryMethod = {};
    this.rootScope.activeCustTab.otcData.selectedPhoneNumber = '';
    this.rootScope.activeCustTab.otcData.selectedEmail = '';
    this.rootScope.activeCustTab.otcData.typedOTC = '';  
    this.rootScope.activeCustTab.otcData.validateOtcFail = false;
    this.rootScope.activeCustTab.otcData.validateOtcLocked = false;
    this.rootScope.activeCustTab.otcData.validateOtcApiFailure = false; 
    this.rootScope.activeCustTab.otcData.otcExpired = false;

    this.otcService.oneTimeCode.reset();
    this.otcService.oneTimeCode.enable();
    this.logger.infoLogs('OTC Cancel Verify Code Clicked for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);

  }

  /**
   * Checks if the specified delivery method type is available.
   * @param type - The type of delivery method to check.
   * @returns A boolean indicating whether the delivery method is available.
   */
  isDeliveryMethodAvailable(type: string): boolean {
    if (type === Constants.OTC_MODES.TEXT) {
      return this.rootScope.activeCustTab.otcData?.otcConfigData?.deliveryMethods?.some(method => method?.type === Constants.OTC_MODES.TEXT);
    } else if (type === Constants.OTC_MODES.EMAIL) {
      return this.rootScope.activeCustTab.otcData?.otcConfigData?.deliveryMethods?.some(method => method?.type === Constants.OTC_MODES.EMAIL);
    }
    return false;
  }

  /**
   * Returns the display number for a given option.
   * 
   * @param opt - The option object containing the extension and phone number.
   * @returns The formatted display number.
   */
  getDisplayNumber(opt) {
    return `${opt?.countryCode ? opt?.countryCode + ' ' : ''}${opt?.phoneNumber}`;
  }


  /**
   * Handles the selection of a phone number option.
   * Updates the selected phone number and country code in the root scope.
   */
  onPhoneNumberSelect(option: any) {
    this.rootScope.activeCustTab.otcData.selectedPhoneNumber = option?.phoneNumber;
    this.rootScope.activeCustTab.otcData.selectedCountryCode = option?.countryCode;
  }


  /**
   * Handles the selection of an email option.
   * Updates the selected email in the root scope.
   */
  getSelectedOption() {
    const selectedOption = this.rootScope.activeCustTab?.otcData?.otcConfigData?.deliveryMethods
    ?.find(method => method?.type == Constants.OTC_MODES.TEXT)
    ?.details?.find(detail => detail?.phoneNumber == this.rootScope.activeCustTab.otcData.selectedPhoneNumber &&  detail?.countryCode == this.rootScope.activeCustTab.otcData.selectedCountryCode);
  
    if (selectedOption) {
      this.selectedOption = selectedOption;   
    }

  }

  /* -- CCR1-10049 needs ti be added back for country code dialog angular story -- */
  // /**
  //  * Gets the formatted display value for the selected phone/email.
  //  * @returns The formatted display value.
  //  */
  // get selectedOtcDisplayValue(): string {
  //   const otcData = this.rootScope.activeCustTab.otcData;
  //   if (otcData.selectedDeliveryMethod?.type === 'email') {
  //     return otcData.selectedEmail;
  //   }
  //   const opt = otcData.selectedDeliveryMethod?.details?.find(
  //     o => o.phoneNumber === otcData.selectedPhoneNumber
  //   );
  //   return opt ? this.getDisplayNumber(opt) : '';
  // }

  ngOnDestroy() {
    this.rootScope.activeCustTab.otcData.validateOTCApiProcessing = false;
}

}


